exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".grid-lista-aplicaciones{\r\n   display: block;\r\n   padding: 0;\r\n   margin-top: 6px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/portal/components/contenedor-aplicaciones/lista-aplicaciones/lista-aplicaciones.style.css
// module id = 636
// module chunks = 0